import { supabase } from '../../../shared/lib/supabaseClient';
import { ROLES } from '../../../shared/constant/roles';
import { logActivity, backfillActorName } from '../../../shared/services/activityLogService';

export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  await logActivity('login', 'Logged in');
  return data;
}

export async function signUp(email, password, metadata = {}) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: metadata,
      emailRedirectTo: `${window.location.origin}/complete-profile`,
    },
  });
  if (error) throw error;
  if (data.session) {
    await logActivity('signup', 'Created an account');
  }
  return data;
}

export async function updateProfile(profileData) {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();
  if (userError) throw userError;

  const { error: upsertError } = await supabase.from('officers').upsert({
    auth_id: user.id,
    email: user.email,
    role: ROLES.OFFICER,
    status: 'Active',
    approved: false,
    ...profileData,
  });
  if (upsertError) throw upsertError;

  const { data, error } = await supabase.auth.updateUser({
    data: { profile_completed: true },
  });
  if (error) throw error;

  const actorName = `${profileData.firstname ?? ''} ${profileData.lastname ?? ''}`.trim();
  await backfillActorName(user.id, actorName);
  await logActivity('profile_completed', `Completed profile setup as ${profileData.position || 'officer'}`);
  return data;
}

export async function getOwnOfficerStatus() {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();
  if (userError) throw userError;

  const { data, error } = await supabase
    .from('officers')
    .select('approved')
    .eq('auth_id', user.id)
    .maybeSingle();
  if (error) throw error;

  return data?.approved ?? false;
}

export async function signOut() {
  await logActivity('logout', 'Logged out');
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export function getSession() {
  return supabase.auth.getSession();
}

export function onAuthStateChange(callback) {
  return supabase.auth.onAuthStateChange(callback);
}
